<div id="whatsapp-icon" *ngIf="environmentVariable">
    <a href="https://wa.me/{{environmentVariable}}"><img src="/assets/whatsapp-logo.png"></a>
</div>
